/* eslint-disable*/
import React from "react";
import SystemMaintenanceSpecialFunctions_LoanInterestProfile from "./LoanInterestProfile";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("LoanInterestProfile Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceSpecialFunctions_LoanInterestProfile />
      );
    });
  });
  afterEach(cleanup);
  test("is LoanInterestProfile Loads Successfully", () => {
    expect(screen.getByText("LoanInterestProfile")).toBeInTheDocument;
  });
  test("Custom Test Cases for LoanInterestProfile", () => {
    // START_USER_CODE-USER_LoanInterestProfile_Custom_Test_Case
    // END_USER_CODE-USER_LoanInterestProfile_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceSpecialFunctions_LoanInterestProfile />
      );
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestProfile_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnCancel(Button Widget) Test Cases", async () => {
    const btnCancel = screen.getByTestId("btnCancel");
    expect(btnCancel).toBeInTheDocument;
    expect(btnCancel.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestProfile_btnCancel")
    );
  });
  test("Custom Test Cases for btnCancel", () => {
    // START_USER_CODE-USER_btnCancel_TEST
    // END_USER_CODE-USER_btnCancel_TEST
  });
  test("grpbcLoanInterestProfile(GroupBox Widget) Test Cases", async () => {
    const grpbcLoanInterestProfile = screen.getByTestId(
      "grpbcLoanInterestProfile"
    );
    expect(grpbcLoanInterestProfile.tagName).toBe("BUTTON");
    expect(grpbcLoanInterestProfile.type).toBe("button");
    expect(grpbcLoanInterestProfile.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbcLoanInterestProfile", () => {
    // START_USER_CODE-USER_grpbcLoanInterestProfile_TEST
    // END_USER_CODE-USER_grpbcLoanInterestProfile_TEST
  });
  test("grpbxActions(GroupBox Widget) Test Cases", async () => {
    const grpbxActions = screen.getByTestId("grpbxActions");
    expect(grpbxActions.tagName).toBe("BUTTON");
    expect(grpbxActions.type).toBe("button");
    expect(grpbxActions.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxActions", () => {
    // START_USER_CODE-USER_grpbxActions_TEST
    // END_USER_CODE-USER_grpbxActions_TEST
  });
  test("lblAddedBy(Label Widget) Test Cases", async () => {
    const lblAddedBy = screen.getByTestId("lblAddedBy");
    expect(lblAddedBy.tagName).toBe("LABEL");
    expect(lblAddedBy.classList).toContain("form-label");
    expect(lblAddedBy.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestProfile_lblAddedBy")
    );
  });
  test("Custom Test Cases for lblAddedBy", () => {
    // START_USER_CODE-USER_lblAddedBy_TEST
    // END_USER_CODE-USER_lblAddedBy_TEST
  });
  test("lblAddedByValue(Label Widget) Test Cases", async () => {
    const lblAddedByValue = screen.getByTestId("lblAddedByValue");
    expect(lblAddedByValue.tagName).toBe("LABEL");
    expect(lblAddedByValue.classList).toContain("form-label");
  });
  test("Custom Test Cases for lblAddedByValue", () => {
    // START_USER_CODE-USER_lblAddedByValue_TEST
    // END_USER_CODE-USER_lblAddedByValue_TEST
  });
  test("lblChangedBy(Label Widget) Test Cases", async () => {
    const lblChangedBy = screen.getByTestId("lblChangedBy");
    expect(lblChangedBy.tagName).toBe("LABEL");
    expect(lblChangedBy.classList).toContain("form-label");
    expect(lblChangedBy.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestProfile_lblChangedBy")
    );
  });
  test("Custom Test Cases for lblChangedBy", () => {
    // START_USER_CODE-USER_lblChangedBy_TEST
    // END_USER_CODE-USER_lblChangedBy_TEST
  });
  test("lblChangedByValue(Label Widget) Test Cases", async () => {
    const lblChangedByValue = screen.getByTestId("lblChangedByValue");
    expect(lblChangedByValue.tagName).toBe("LABEL");
    expect(lblChangedByValue.classList).toContain("form-label");
    expect(lblChangedByValue.textContent).toEqual(
      t(
        "SystemMaintenanceSpecialFunctions:LoanInterestProfile_lblChangedByValue"
      )
    );
  });
  test("Custom Test Cases for lblChangedByValue", () => {
    // START_USER_CODE-USER_lblChangedByValue_TEST
    // END_USER_CODE-USER_lblChangedByValue_TEST
  });
  test("txtInterestRate(Textbox Widget) Test Cases", async () => {
    const txtInterestRate = screen.getByTestId("txtInterestRate");
    expect(txtInterestRate.tagName).toBe("INPUT");
    expect(txtInterestRate.type).toBe("text");
    expect(txtInterestRate.classList).toContain("textboxWidgetClass");
    expect(txtInterestRate.previousElementSibling.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestProfile_txtInterestRate")
    );
    await act(async () => {
      userEvent.type(txtInterestRate, "1");
    });
  });
  test("Custom Test Cases for txtInterestRate", () => {
    // START_USER_CODE-USER_txtInterestRate_TEST
    // END_USER_CODE-USER_txtInterestRate_TEST
  });
});
